import { AlertTitle, AlertType } from '@app/components/Alert';
import Alerts from '@app/components/Alerts';
import { CartAlertsProvider } from '@app/context/CartAlertsContext';
import useAddProductsToCart from '@app/hooks/useAddProductsToCart';
import type { AlertItem } from '@app/hooks/useAlerts';

const AddToCartErrors = () => {
  const { addToCartErrors } = useAddProductsToCart();
  return (
    <CartAlertsProvider>
      <Alerts
        alerts={[
          ...(addToCartErrors?.length
            ? addToCartErrors.map(
                (error): AlertItem => ({
                  type: error ? AlertType.Error : AlertType.Success,
                  content: (
                    <AlertTitle>
                      {error.message} {error?.code && `(code: ${error.code}`}
                    </AlertTitle>
                  ),
                }),
              )
            : []),
        ]}
      />
    </CartAlertsProvider>
  );
};

export default AddToCartErrors;
